import { Flexbox, Form } from '@/components'
import { ValidationForm } from '@/components/Form/styles'
import { Button } from '@/components/styles'
import yup from '@/lib/yupPt'
import stalls from '@/services/api/stalls'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { toast } from 'react-toastify'

const schema = yup.object().shape({
  name: yup.string().trim().required(),
  code: yup.string().trim().required(),
  capacity: yup.number()
    .transform((value, originalValue) => (
      originalValue === '' || originalValue === null || originalValue === undefined ? null : value
    ))
    .nullable()
    .integer()
    .min(1),
})

function FormStall({ onSuccess, stall, ButtonComponent }) {
  const [active, setActive] = useState(false)
  const [loading, setLoading] = useState(false)

  function close() {
    if (!loading) setActive(false)
  }

  async function onSubmit(values) {
    const capacity = values.capacity === '' || values.capacity === null || values.capacity === undefined
      ? null
      : Number(values.capacity)
    const body = {
      name: values.name,
      code: values.code,
      capacity,
    }
    try {
      setLoading(true)
      const res = stall
        ? await stalls.update(stall.id, body)
        : await stalls.create(body)
      toast.success(`Baia ${stall ? 'atualizada' : 'adicionada'} com sucesso`)
      onSuccess(res.data)
      close()
    } catch (e) {
      toast.error(e?.message || 'Ocorreu um erro ao salvar a baia')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <ButtonComponent onClick={() => setActive(true)} />
      {
        active && (
          <Form.Formik
            initialValues={{
              name: stall ? stall.name : '',
              code: stall ? stall.code : '',
              capacity: stall?.capacity ?? '',
            }}
            validationSchema={schema}
            onSubmit={onSubmit}
            validateOnMount
          >
            {
              ({
                touched, errors, isValid,
              }) => (
                <fieldset disabled={loading}>
                  <ValidationForm>
                    <div className={`modal ${active ? 'active' : ''} text-left`}>
                      <a type="button" className="modal-overlay" aria-label="Close" onClick={close} />
                      <div className="modal-container">
                        <div className="modal-header">
                          <a
                            type="button"
                            className="btn btn-clear float-right"
                            onClick={close}
                          />
                          <div className="modal-title h5">
                            {stall ? 'Editar baia' : 'Adicionar baia'}
                          </div>
                        </div>
                        <div className="modal-body">
                          <Flexbox.Columns>
                            <Flexbox.Column className="col-12">
                              <Form.Group className={`${touched?.name && errors?.name ? 'has-error' : ''}`}>
                                <Form.Label htmlFor="name">Nome <span className="text-error">*</span></Form.Label>
                                <Form.ValidationField
                                  name="name"
                                  id="name"
                                  placeholder="Ex: Baia 1"
                                />
                                {
                                  touched?.name && errors?.name
                                    ? <Form.Hint className="text-error">{errors.name}</Form.Hint> : null
                                }
                              </Form.Group>
                            </Flexbox.Column>
                            <Flexbox.Column className="col-6 col-sm-12">
                              <Form.Group className={`${touched?.code && errors?.code ? 'has-error' : ''}`}>
                                <Form.Label htmlFor="code">Código <span className="text-error">*</span></Form.Label>
                                <Form.ValidationField
                                  name="code"
                                  id="code"
                                  placeholder="Ex: B1"
                                />
                                {
                                  touched?.code && errors?.code
                                    ? <Form.Hint className="text-error">{errors.code}</Form.Hint> : null
                                }
                              </Form.Group>
                            </Flexbox.Column>
                            <Flexbox.Column className="col-6 col-sm-12">
                              <Form.Group className={`${touched?.capacity && errors?.capacity ? 'has-error' : ''}`}>
                                <Form.Label htmlFor="capacity">Capacidade</Form.Label>
                                <Form.ValidationField
                                  name="capacity"
                                  id="capacity"
                                  type="number"
                                  min="1"
                                  placeholder="Ex: 4"
                                />
                                {
                                  touched?.capacity && errors?.capacity
                                    ? <Form.Hint className="text-error">{errors.capacity}</Form.Hint> : null
                                }
                              </Form.Group>
                            </Flexbox.Column>
                          </Flexbox.Columns>
                        </div>
                        <div className="modal-footer">
                          <Button
                            type="submit"
                            disabled={!isValid}
                            className={`btn-sm btn-primary ml-2 ${loading ? 'loading' : ''}`}
                          >
                            <i className="fas fa-paper-plane" />
                            &nbsp;Enviar
                          </Button>
                        </div>
                      </div>
                    </div>
                  </ValidationForm>
                </fieldset>
              )
            }
          </Form.Formik>
        )
      }
    </div>
  )
}

FormStall.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  stall: PropTypes.objectOf(Object),
  ButtonComponent: PropTypes.elementType.isRequired,
}

FormStall.defaultProps = {
  stall: null,
}

export default FormStall
